<template>
  <div class="player-panel-my-playlist">
    <div class="creation">
      <div class="list-header">
        {{ $t('PLAYER.MY_PLAYLIST') }} ({{ countUserPlaylist }})
      </div>
      <div class="list-body">
        <div v-for="playlist in userPlaylist" :key="playlist.id" class="list-item">
          <RouterLink
            :style="coverBackgroundImage(playlist)"
            :to="{ name:'playlistById', params:{ locale: $i18n.localePath(), id: playlist.id} }"
            tag="div" class="cover"
          >
            <!--  -->
          </RouterLink>
          <div class="name">
            <RouterLink :to="{name:'playlistById', params:{ locale: $i18n.localePath(), id: playlist.id }}" tag="div" class="title">
              {{ displayLocaleTitle(playlist) }}
            </RouterLink>
            <div v-if="playlist.tracks" class="count">
              {{ $t('PLAYER.NUM_OF_SONGS', {num: playlist.tracks.length}) }}
            </div>
          </div>
          <a class="btn" @click="setPlaylistToQueue(playlist)">
            <PlayerStaticPlayBtn :width="40" :height="40" />
          </a>
        </div>
        <div v-if="userPlaylist && userPlaylist.length === 0" class="list-empty">
          <div class="list-empty-item img">
            <img src="@/assets/images/player/img-myplaylist-empty.png" alt="My playlist">
          </div>
          <div class="list-empty-item text">
            {{ $t('PLAYER.CREATE_YOUR_OWN_PLAYLISTS') }}
            <RouterLink :to="{name:'memberPage', params: { locale: $i18n.localePath(), id: profile.id }}" class="try-it-link">
              {{ $t('PLAYER.TRY_IT') }} <i class="material-icons">
                chevron_right
              </i>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
    <div class="collection">
      <div class="list-header">
        {{ $t('PLAYER.MY_FOLLOWING') }}  ({{ countUserFollowing }})
      </div>
      <div class="list-body">
        <div v-for="playlist in userFollowing" :key="playlist.id" class="list-item">
          <RouterLink
            :style="coverBackgroundImage(playlist)"
            :to="{ name:'playlistById', params:{locale: $i18n.localePath(), id: playlist.id} }"
            class="cover"
          >
            <!--  -->
          </RouterLink>
          <RouterLink :to="{ name:'playlistById', params:{locale: $i18n.localePath(), id: playlist.id} }" class="name">
            {{ displayLocaleTitle(playlist) }}
          </RouterLink>
          <a class="btn" @click="setPlaylistToQueue(playlist, true)">
            <PlayerStaticPlayBtn :width="40" :height="40" />
          </a>
        </div>
        <div v-if="userFollowing && userFollowing.length === 0" class="list-empty">
          <div class="list-empty-item img">
            <img src="@/assets/images/player/img-collection-empty.png" alt="">
          </div>
          <div class="list-empty-item text">
            {{ $t('PLAYER.SAVE_PLAYLISTS_TO_YOURS') }}
            <RouterLink :to="{name:'scenarioById', params: {locale: $i18n.localePath(), id: '8bab9370-864f-48f8-81bf-db3decb14028'}}" class="try-it-link">
              {{ $t('PLAYER.TRY_IT') }} <i class="material-icons">
                chevron_right
              </i>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ImgLoader from '@/directives/ImgLoader'
import PlayerStaticPlayBtn from '@/components/player/PlayerStaticPlayBtn'
import { displayLocaleTitle } from '@/assets/helpers/PlaylistHelper'
import PlaylistService from '@/assets/services/PlaylistService'
import { getCookie } from '@/assets/helpers/UtilHelper'

export default {
  name: 'PlayerPanelMyPlaylist',
  components: {
    PlayerStaticPlayBtn
  },
  directives: {
    ImgLoader
  },
  props: {},
  data() {
    return {
      trackList: []
    }
  },
  computed: {
    ...mapState({
      profile: state => state.user.profile,
      userPlaylist: state => state.user.playlist,
      userFollowing: state => state.user.following,
      display: state => state.player.display,
      initialClick: state => state.player.initialClick,
      random: state => state.player.random,
      paused: state => state.player.paused,
      currentTime: state => state.player.currentTime,
      queue: state => state.player.queue,
      isAnyPgnnpAudio: state => state.player.isAnyPgnnpAudio
    }),
    countUserPlaylist() {
      return this.userPlaylist ? this.userPlaylist.length : 0
    },
    countUserFollowing() {
      return this.userFollowing ? this.userFollowing.length : 0
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayLocaleTitle,
    getCookie,
    coverBackgroundImage(playlist) {
      return playlist && playlist['file_link']
        ? { backgroundImage: `url(${playlist['file_link']})` }
        : {}
    },
    async setPlaylistToQueue(playlist, isFollowingList = false) {
      const isFirstPlay = this.getCookie('player_play_count') === null
      if (isFirstPlay) {
        this.$store.commit('SET_TO_PREPEND', true)
        this.$store.dispatch('PGNNP_AUDIO_NEXT')
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else if (!this.initialClick) { // Preset, should before API request (async/await)!!
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
      if (!this.display) {
        this.$store.commit('TOGGLE_PLAYER_DISPLAY', true)
      }
      if (this.random) {
        this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
      }
      // load track list
      let trackList = []
      if (playlist && (isFollowingList || !playlist.tracks || playlist.tracks.length === 0)) {
        const res = await PlaylistService.getPlaylistById(playlist.id)
        trackList = res.tracks
      } else {
        trackList = playlist.tracks
      }
      if (playlist && trackList && trackList.length > 0) {
        this.$store.commit('RESET_QUEUE')
        this.$store.commit('SET_PLAYLIST_TO_QUEUE', trackList)
        this.$store.commit('SET_PLAYER_INDEX', 0)
        if (!this.paused || this.currentTime > 0) {
          this.$store.dispatch('INCREASE_PLAYING_COUNT')
        }
        this.$nextTick(() => {
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false) // trigger auto play
        })
      } else {
        this.$store.commit('ALERT_MESSAGE', { message: 'PLAYLIST.EMPTY_TRACKS_TEXT', type: 'error' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/player.scss';

.player-panel-my-playlist {
  height: calc(#{$player-panel-height} - #{$player-tab-height});
  overflow-x: hidden;
  overflow-y: scroll;
}
.list {
  &-header {
    height: $player-panel-title-height;
    padding: 0 24px;
    font-size: 12px;
    color: $grey-7d;
    line-height: $player-panel-title-height; // vertical align middle
    border-bottom: solid 1px $grey-ec;
  }
  &-body {
    min-height: 24px;
    border-bottom: solid 1px $grey-ec;
  }
  &-item {
    position: relative;
    height: $player-panel-item-height;
    padding: 0 24px;
    border-bottom: solid 1px $grey-ec;
    &:last-child {
      border-bottom: none;
    }

    .cover {
      position: absolute;
      top: calc((100% - 40px) / 2);
      left: 24px;
      width: 40px;
      height: 40px;
      margin-right: 16px;
      border-radius: 12px;
      cursor: pointer;

      background-color: $grey-ec;
      background-image: url('/img/img-default/img-playlist-default-l.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      img {
        width: 40px;
        height: 40px;
        border-radius: 12px;
      }
    }
    .name {
      position: absolute;
      top: 0;
      left: calc(24px + 40px + 16px);
      width: calc(100% - 48px - 64px - 40px); // TODO update
      line-height: 65px;
      font-size: 20px;
      font-weight: 500;
      color: $grey-50;
      text-decoration: none;
      @include ellipsis-with-nowrap();
      .title {
        padding-top: 8px;
        font-size: 20px;
        line-height: 1.6; // 32px
        cursor: pointer;
        @include ellipsis-with-nowrap();
      }
      .count {
        height: 18px;
        font-size: 12px;
        line-height: 1.5; // 18px
        color: $grey-9b;
      }
    }
    .btn {
      position: absolute;
      top: calc((100% - 40px) / 2);
      right: 24px;
      height: 40px;
      width: 40px;
      cursor: pointer;
      &-wrapper{
        display: inline-block;
        width: 100%;
      }
    }
  }

  &-empty {
    padding: 11px 30px;
    &-item {
      display: inline-block;
      vertical-align: middle;
      width: 230px;
      &.img {
        margin-right: 16px;
      }
      &.text {
        margin: 16px 0;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.6;
        .try-it-link {
          display: block;
          font-size: 14px;
          font-weight: 500;
          line-height: 32px;
          color: $link-hover;
          text-decoration: none;
          i {
            font-size: 14px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}
@media only screen and (max-width: 767.98px) {
  $player-panel-height: 445px;
  $player-panel-margin: 0;
  $player-panel-width: 100%;
  $player-tab-height: 48px;
  $player-panel-title-height: 36px;

  .player-panel-playlist {
    height: calc(#{$player-panel-height} - #{$player-tab-height});
  }
  .list {
    &-header {
      height: $player-panel-title-height;
      line-height: $player-panel-title-height; // vertical align middle
    }
    &-empty {
      padding: 11px 30px;
      text-align: center;
      &-item {
        width: 100%;
        &.img {
          margin-right: 16px;
        }
        &.text {
          margin: 16px 0;
          .try-it-link {
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>
